/**
 * 결제 결과 페이지 (단건 + 정기결제)
 * FSD: features/subscription/checkout/ui
 */

import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { apiClient } from "@/shared/api/client";

export const BillingKeyResult: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState<"loading" | "success" | "error">(
    "loading"
  );
  const [message, setMessage] = useState("결제 처리 중...");
  const [transactionId, setTransactionId] = useState<string | null>(null);

  useEffect(() => {
    processPaymentCallback();
  }, []);

  const processPaymentCallback = async () => {
    try {
      const authResultCode = searchParams.get("AuthResultCode");
      const authToken = searchParams.get("AuthToken");
      const TID = searchParams.get("tid");

      // 성공 코드: 0000 (일반 결제), 3001 (빌링키 발급 성공)
      const isSuccess = authResultCode === "0000" || authResultCode === "3001";

      if (!authToken || !isSuccess) {
        const errorMsg = searchParams.get("AuthResultMsg") || "결제 인증 실패";
        throw new Error(errorMsg);
      }

      // 상품 타입 판단 (URL 파라미터 또는 session storage에서 가져옴)
      const paymentType = sessionStorage.getItem("paymentType") || "ONE_TIME";

      if (paymentType === "ONE_TIME") {
        setStatus("success");
        setMessage("결제가 완료되었습니다");
        setTransactionId(TID || null);

        setTimeout(() => {
          navigate(`/payment/history`);
        }, 2000);
      } else {
        setStatus("success");
        setMessage("정기결제 신청이 완료되었습니다");
        setTransactionId(TID || null);

        setTimeout(() => {
          navigate(`/subscription/manage`);
        }, 2000);
      }

      // 성공 후 sessionStorage 정리
      sessionStorage.removeItem("paymentType");
    } catch (error: any) {
      setStatus("error");
      setMessage(`오류 발생: ${error.message}`);
      sessionStorage.removeItem("paymentType");

      // setTimeout(() => {
      //   navigate(-1);
      // }, 5000);
    }
  };

  return (
    <div className="billing-key-result-page">
      <div className="result-container">
        {status === "loading" && (
          <div className="loading-state">
            <div className="spinner"></div>
            <p>빌링키 처리 중...</p>
          </div>
        )}

        {status === "success" && (
          <div className="success-state">
            <div className="success-icon">✓</div>
            <h2>구독 신청 성공</h2>
            <p className="message">{message}</p>
            {transactionId && (
              <div className="subscription-info">
                <p className="label">거래 ID</p>
                <p className="subscription-id">{transactionId}</p>
              </div>
            )}
            <p className="redirect-notice">
              잠시 후 구독 관리 페이지로 이동합니다...
            </p>
          </div>
        )}

        {status === "error" && (
          <div className="error-state">
            <div className="error-icon">✗</div>
            <h2>구독 신청 실패</h2>
            <p className="message">{message}</p>
            <p className="redirect-notice">
              잠시 후 이전 페이지로 돌아갑니다...
            </p>
          </div>
        )}
      </div>
    </div>
  );
};
